import { OChainId } from 'modules/api';
import { getExtendedErrorText } from 'modules/common/utils/getExtendedErrorText';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';
import { CommonCacheTags, web3Api } from 'store/web3Api';

import { getUserVaultSupply } from './utils/getUserVaultSupply';

export const { useGetUserLbtcVaultSupplyQuery } = web3Api.injectEndpoints({
  endpoints: build => ({
    getUserLbtcVaultSupply: build.query<number, string>({
      queryFn: queryFnNotifyWrapper<string, never, number>(
        async address => {
          const ethSupply = await getUserVaultSupply(
            address,
            OChainId.ethereum,
          );

          const sonicSupply = await getUserVaultSupply(address, OChainId.sonic);

          return {
            data: ethSupply + sonicSupply,
          };
        },
        error =>
          getExtendedErrorText(error, 'Unable to get User LBTC vault supply'),
      ),
      providesTags: [
        CommonCacheTags.evmTokenBalance,
        CommonCacheTags.userLbtcVaultBalance,
      ],
    }),
  }),
});
